import Reveal from '@/components/base/Reveal';
import { performerInfo } from '@/mocks/site';

const genres = ['PERFORMANCE', 'DANCE', 'STREET', 'WORKSHOP', 'LIVE'];

export default function Performer() {
  return (
    <section id="performer" className="border-t border-background-200/60 bg-background-50 px-5 py-16 pr-14 md:px-10 md:py-24 md:pr-20">
      <div className="mx-auto max-w-6xl">
        <div className="grid items-center gap-8 md:grid-cols-12 md:gap-12">
          <Reveal variant="mask" duration={1200} className="md:col-span-7 md:order-1">
            <div className="h-[260px] w-full overflow-hidden rounded-md sm:h-[360px] md:h-[440px]">
              <img
                src={performerInfo.image}
                alt="夕暮れの屋外ステージでパフォーマンスをする出演者"
                className="animate-ken-burns h-full w-full object-cover"
              />
            </div>
          </Reveal>

          <div className="md:col-span-5">
            <Reveal variant="up">
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-primary-500" />
                <p className="text-[10px] en-label text-primary-600">{performerInfo.en}</p>
              </div>
              <h2 className="mt-4 font-heading text-[25px] font-black leading-[1.35] text-foreground-950 md:text-[32px]">
                出演者・
                <br className="hidden md:block" />
                パフォーマー募集
              </h2>
              <p className="mt-5 text-[13px] leading-[2] text-foreground-700">{performerInfo.lead}</p>
            </Reveal>

            <Reveal variant="up" delay={120}>
              <div className="mt-5 flex flex-wrap gap-2">
                {genres.map((genre) => (
                  <span
                    key={genre}
                    className="rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 text-[9.5px] en-label text-secondary-800"
                  >
                    {genre}
                  </span>
                ))}
              </div>
            </Reveal>

            <Reveal variant="up" delay={180} className="mt-6">
              <dl className="divide-y divide-background-300 border-y border-background-300">
                {performerInfo.items.map((row) => (
                  <div key={row.label} className="flex flex-col gap-1 py-3 sm:flex-row sm:gap-5">
                    <dt className="w-24 shrink-0 text-[11.5px] font-bold text-foreground-500">{row.label}</dt>
                    <dd className="text-[12.5px] leading-relaxed text-foreground-800">{row.value}</dd>
                  </div>
                ))}
              </dl>
            </Reveal>

            <Reveal variant="up" delay={240}>
              <a
                href="#contact"
                className="mt-6 inline-flex cursor-pointer items-center gap-2 rounded-md border border-foreground-300 px-5 py-3 text-[12.5px] font-bold text-foreground-900 transition-colors duration-300 hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
              >
                <i className="ri-mic-line text-sm" aria-hidden="true" />
                出演について問い合わせる
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}